export enum EntryType {
  Boolean = 'boolean',
  Simple = 'simple',
  Graph = 'graph',
  Internal = 'internal',
  Cell = 'cell',
  Map = 'map',
  Code = 'code',
}

// Map entries are containers, not leaf values, so they are excluded from item-level operations.
export type EntryItemType = Exclude<EntryType, EntryType.Map>;
